export default __webpack_public_path__ + "static/media/notification.1476764b.mp3";